import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, MessageCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const MatchModal = ({ profile, onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center animate-in zoom-in duration-300">
        <div className="mb-6">
          <div className="relative inline-block">
            <Heart className="w-20 h-20 text-pink-500 mx-auto animate-pulse" fill="#ec4899" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-2">It's a Match!</h2>
        <p className="text-gray-600 mb-6">
          You and {profile.name} have liked each other
        </p>

        <div className="mb-6">
          <img
            src={profile.photos[0]}
            alt={profile.name}
            className="w-32 h-32 rounded-full object-cover mx-auto shadow-lg"
          />
          <h3 className="text-xl font-semibold text-gray-900 mt-4">
            {profile.name}, {profile.age}
          </h3>
          {profile.distance_km !== null && profile.distance_km !== undefined && (
            <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-2">
              <MapPin className="w-4 h-4" />
              <span>{Math.round(profile.distance_km)} km away</span>
            </div>
          )}
        </div>

        <div className="space-y-3">
          <Button
            className="w-full bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white"
            onClick={() => {
              onClose();
              navigate(`/messages/${profile.id}`);
            }}
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            Send a Message
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={onClose}
          >
            Keep Swyping
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MatchModal;
